// Options for the Approve Event dialog (D4URX-2750).

// Values must match the events.organization_type ENUM in d4urx-api
// (db/migrations/D4URX-2750-event-approval-classification.sql).
export const ORGANIZATION_TYPES = [
  { value: 'school', label: 'Schools/Youth Programs' },
  { value: 'community_org', label: 'Community Organizations' },
];

// Subcategories offered for each organization type (D4URX-2760), stored in
// events.organization_subcategory. Values must match ORGANIZATION_SUBCATEGORIES in d4urx-api's
// D4URAdmin event routes, which rejects any value not listed for the chosen type.
export const ORGANIZATION_SUBCATEGORIES: Record<string, { value: string; label: string }[]> = {
  school: [
    { value: 'school_sports', label: 'School Sports' },
    { value: 'youth_sports', label: 'Youth Sports' },
    { value: 'arts_band', label: 'Arts + Band' },
    { value: 'general_school_funding', label: 'General School Funding' },
    { value: 'youth_programs', label: 'Youth Programs' },
    { value: 'scholarships', label: 'Scholarships' },
    { value: 'workforce', label: 'Workforce (Auto, Tech, Vocational, etc. Programs)' },
    { value: 'field_park', label: 'Updating Field/Park' },
    { value: 'entrepreneurship', label: 'Entrepreneurship + Skill Development' },
  ],
  community_org: [
    { value: 'build', label: 'Build' },
    { value: 'rebuild', label: 'Rebuild' },
  ],
};

// Display labels for a stored organization_type / organization_subcategory; '' when unset or unknown.
export const organizationTypeLabel = (type?: string | null): string =>
  ORGANIZATION_TYPES.find((t) => t.value === type)?.label || '';

export const organizationSubcategoryLabel = (type?: string | null, subcategory?: string | null): string =>
  (ORGANIZATION_SUBCATEGORIES[type || ''] || []).find((sub) => sub.value === subcategory)?.label || '';

// Stored in events.fbt_partner (not nat_charity, the dealer's own pick); must match FBT_PARTNERS in d4urx-api's D4URAdmin event routes.
export const FBT_PARTNERS = [
  'Feeding America',
  'Habitat for Humanity',
  'Team Rubicon',
  'American Red Cross',
  'World Central Kitchen',
];

// Copied exactly from the dealer portal's request form (ford-d4urx-dealer-portal EligibilityForm),
// spacing included, so the dealer's answer matches an option when the dialog prefills it.
export const FUNDING_PURPOSE_CATEGORIES = [
  'Community Development (Build / Restore Community Spaces)',
  'Publicly Available Parks / Playgrounds / Spaces',
  'Workforce Development (Vocational / Trades / Auto Tech)',
  'Scholarships (Vocational / Trades / Entrepreneurship)',
  'Small Business / Entrepreneurship Skill-Based Learning',
  'Housing / Neighborhood Revitalization (e.g., Habitat for Humanity)',
  'Hunger Relief / Food Security (e.g., Feeding America, World Central Kitchen)',
  'Emergency / Disaster Preparedness, Response & Recovery (e.g.,  American Red Cross, Team Rubicon)',
];
